(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion-component-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accordion-item-filter')) {
    customElements.define(
      'accordion-item-filter',
      class AccordionItemFilter extends HTMLElement {
        constructor() {
          super();
          this.heading = this.querySelector('.accordion-container__heading-area');
          this.content = this.querySelector('.accordion-container__content');
          this.type = this.dataset.type || 'normal';

          this.heading.addEventListener('click', this.singleToggleAccordion.bind(this));

          if (this.type == 'sort_by') {
            this.addEventListener('input', (e) => {
              console.log(e.target.dataset.name);
              document.querySelector('#sort_title').innerText = e.target.dataset.name;
            });
          }
        }

        singleToggleAccordion() {
          this.querySelector('.accordion-container__content').style.height = '0px';
          const isOpen = this.classList.contains('open');

          if (isOpen) {
            this.closeAccordion();
          } else {
            this.openAccordion();
          }
        }

        toggleAccordion() {
          this.closest('filter-drawer')
            .querySelectorAll('accordion-item-filter')
            .forEach((item) => {
              if (item !== this) {
                item.classList.remove('open');
                item.querySelector('.accordion-container__content').style.height = '0px';
              }
            });

          const isOpen = this.classList.contains('open');

          if (isOpen) {
            this.closeAccordion();
          } else {
            this.openAccordion();
          }
        }

        openAccordion() {
          this.classList.add('open');
          const contentHeight = this.content.scrollHeight;
          this.content.style.height = `${contentHeight + 3}px`;
        }

        closeAccordion() {
          this.classList.remove('open');
          this.content.style.height = '0px';
        }

        connectedCallback() {
          // Initial collapse
          this.content.style.height = '0px';
          this.content.style.opacity = '1';

          const filterDrawer = this.closest('filter-drawer');
          if (!filterDrawer) return;

          // Ensure _accordions exists
          if (!filterDrawer._accordions) {
            filterDrawer._accordions = [];
            this.setupFilterDrawerListeners(filterDrawer);
          }

          // Avoid duplicate pushes
          if (!filterDrawer._accordions.includes(this)) {
            filterDrawer._accordions.push(this);
          }

          // Only open first accordion if this is the *first time*
          if (filterDrawer._accordions.length === 1) {
            this.openAccordion();
          } else {
            this.closeAccordion();
          }
        }

        disconnectedCallback() {
          // Clean up reference when element is removed
          const filterDrawer = this.closest('filter-drawer');
          if (filterDrawer && filterDrawer._accordions) {
            const index = filterDrawer._accordions.indexOf(this);
            if (index > -1) {
              filterDrawer._accordions.splice(index, 1);
            }
          }
        }

        setupFilterDrawerListeners(filterDrawer) {
          // Listen for filter close event
          filterDrawer.addEventListener('filterClose', (e) => {
            // Close all accordions within this filter drawer
            const accordions = filterDrawer.querySelectorAll('accordion-item-filter');
            setTimeout(() => {
              accordions.forEach((accordion) => {
                accordion.closeAccordion();
              });

              // Open the first accordion if it exists
              if (accordions.length > 0) {
                accordions[0].openAccordion();
              }
            }, 700);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atc-nd-enquiry"] && !Shopify.designMode) return;
  try {
    document.querySelector('#make-enquiry-button').addEventListener('click', () => {
    if (window.innerWidth < 1200) {
      document.querySelector('custom-header').classList.remove('custom-header--hidden');
      document.querySelector('#inquiry__form-button-mobile--open').click();
      setTimeout(() => {
        if (!document.querySelector('#mobile-contact-back').classList.contains('hidden')) {
          document.querySelector('#mobile-contact-back').classList.add('hidden');
        }
        document.querySelector('#mobile-menu__drawer-btn--open').click();
        document.querySelector('custom-header').style.opacity = 1;

        document.querySelector('#mobile-contact-trigger').click();
      }, 200);
    } else {
      document.querySelectorAll('.contact-drawer-trigger').forEach((trigger) => {
        trigger.click();
        document.querySelectorAll('#inquiry-form-panel').forEach((form) => {
          form.classList.remove('hidden');
        });
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-product-club"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('club-product-card')) {
    class ClubProductCard extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.variants = [];
        const jsonEl = this.querySelector('[data-club-variants]');
        if (jsonEl) {
          try {
            this.variants = JSON.parse(jsonEl.textContent);
          } catch (e) {
            this.variants = [];
          }
        }

        this.modal = this.querySelector('[data-club-quickview]');
        this.variantInput = this.modal?.querySelector('[data-club-variant-id]');
        this.priceEl = this.modal?.querySelector('[data-club-price]');
        this.atcBtn = this.modal?.querySelector('[data-club-atc]');
        this.atcLabel = this.modal?.querySelector('[data-club-atc-label]');
        this.errorEl = this.modal?.querySelector('[data-club-error]');
        this.form = this.modal?.querySelector('[data-club-form]');
        this.atcLabelDefault = this.atcLabel?.textContent?.trim() || 'Add to cart';
        this.optionButtons = this.modal
          ? Array.from(this.modal.querySelectorAll('[data-club-option-value]'))
          : [];
        this.selected = {
          1: this.modal?.querySelector(
            '[data-club-option][data-option-position="1"] [data-club-option-value].is-active'
          )?.dataset.value,
          2: this.modal?.querySelector(
            '[data-club-option][data-option-position="2"] [data-club-option-value].is-active'
          )?.dataset.value,
          3: this.modal?.querySelector(
            '[data-club-option][data-option-position="3"] [data-club-option-value].is-active'
          )?.dataset.value,
        };

        this.setupGallery();

        this.querySelector('[data-club-quick-open]')?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.openQuickView();
        });

        this.modal?.querySelectorAll('[data-club-quick-close]').forEach((el) => {
          el.addEventListener('click', () => this.closeQuickView());
        });

        this.optionButtons.forEach((button) => {
          button.addEventListener('click', () => this.onOptionSelect(button));
        });

        this.form?.addEventListener('submit', this.onSubmit.bind(this));
        this.onKeyDown = this.onKeyDown.bind(this);
      }

      setupGallery() {
        this.track = this.modal?.querySelector('[data-club-track]');
        this.slides = this.track ? Array.from(this.track.querySelectorAll('[data-club-slide]')) : [];
        this.thumbs = this.modal ? Array.from(this.modal.querySelectorAll('[data-club-thumb]')) : [];
        this.dots = this.modal ? Array.from(this.modal.querySelectorAll('[data-club-dot]')) : [];
        this.prevBtn = this.modal?.querySelector('[data-club-prev]');
        this.nextBtn = this.modal?.querySelector('[data-club-next]');
        this.currentEl = this.modal?.querySelector('[data-club-slide-current]');
        this.activeIndex = 0;

        if (!this.track || this.slides.length < 2) return;

        this.prevBtn?.addEventListener('click', () => this.goToSlide(this.activeIndex - 1));
        this.nextBtn?.addEventListener('click', () => this.goToSlide(this.activeIndex + 1));

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.goToSlide(Number(thumb.dataset.index)));
        });

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goToSlide(Number(dot.dataset.index)));
        });

        this.track.addEventListener(
          'scroll',
          () => {
            window.clearTimeout(this.scrollTimeout);
            this.scrollTimeout = window.setTimeout(() => this.syncFromScroll(), 60);
          },
          { passive: true }
        );
      }

      goToSlide(index, behavior = 'smooth') {
        if (!this.track || !this.slides.length) return;
        const next = Math.max(0, Math.min(this.slides.length - 1, index));
        const slide = this.slides[next];
        if (!slide) return;
        this.track.scrollTo({ left: slide.offsetLeft, behavior });
        this.setActiveSlide(next);
      }

      goToMediaId(mediaId) {
        if (!mediaId || !this.slides.length) return;
        const index = this.slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
        if (index >= 0) this.goToSlide(index);
      }

      syncFromScroll() {
        if (!this.track || !this.slides.length) return;
        const width = this.track.clientWidth || 1;
        const index = Math.round(this.track.scrollLeft / width);
        this.setActiveSlide(index);
      }

      setActiveSlide(index) {
        this.activeIndex = index;
        if (this.currentEl) this.currentEl.textContent = String(index + 1);

        this.thumbs.forEach((thumb, i) => {
          const active = i === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });

        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
        });

        if (this.prevBtn) this.prevBtn.disabled = index <= 0;
        if (this.nextBtn) this.nextBtn.disabled = index >= this.slides.length - 1;
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeyDown);
        if (this.modal?.parentElement === document.body && this.isConnected) {
          this.appendChild(this.modal);
        }
        document.body.classList.remove('club-qv-open');
      }

      onKeyDown(event) {
        if (!this.modal?.hasAttribute('open')) return;
        if (event.key === 'Escape') {
          this.closeQuickView();
          return;
        }
        if (event.key === 'ArrowLeft') this.goToSlide(this.activeIndex - 1);
        if (event.key === 'ArrowRight') this.goToSlide(this.activeIndex + 1);
      }

      openQuickView() {
        if (!this.modal) return;
        if (this.modal.parentElement !== document.body) {
          document.body.appendChild(this.modal);
        }
        this.modal.hidden = false;
        this.modal.setAttribute('open', '');
        document.body.classList.add('club-qv-open');
        document.addEventListener('keydown', this.onKeyDown);
        this.updateOptionAvailability();
        requestAnimationFrame(() => {
          this.goToSlide(this.activeIndex || 0, 'auto');
        });
        this.modal.querySelector('.club-qv__close')?.focus();
      }

      closeQuickView() {
        if (!this.modal) return;
        this.modal.removeAttribute('open');
        this.modal.hidden = true;
        document.body.classList.remove('club-qv-open');
        document.removeEventListener('keydown', this.onKeyDown);
        this.hideError();
        if (this.modal.parentElement === document.body && this.isConnected) {
          this.appendChild(this.modal);
        }
        this.querySelector('[data-club-quick-open]')?.focus();
      }

      onOptionSelect(button) {
        if (button.disabled) return;
        const position = Number(button.dataset.optionPosition);
        const value = button.dataset.value;
        this.selected[position] = value;

        const optionGroup = button.closest('[data-club-option]');
        optionGroup?.querySelectorAll('[data-club-option-value]').forEach((el) => {
          const active = el === button;
          el.classList.toggle('is-active', active);
          el.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        const selectedLabel = optionGroup?.querySelector('[data-club-option-selected]');
        if (selectedLabel) selectedLabel.textContent = value;

        this.syncVariant();
      }

      findVariant() {
        return this.variants.find((variant) => {
          const o1 = this.selected[1] == null || variant.option1 === this.selected[1];
          const o2 = this.selected[2] == null || variant.option2 === this.selected[2];
          const o3 = this.selected[3] == null || variant.option3 === this.selected[3];
          return o1 && o2 && o3;
        });
      }

      syncVariant() {
        const variant = this.findVariant();
        if (!variant) return;

        if (this.variantInput) this.variantInput.value = variant.id;

        if (this.priceEl) {
          if (variant.compare_html) {
            this.priceEl.innerHTML = `<s>${variant.compare_html}</s>${variant.price_html}`;
          } else {
            this.priceEl.innerHTML = variant.price_html;
          }
        }

        if (variant.media_id) this.goToMediaId(variant.media_id);

        if (this.atcBtn && this.atcLabel) {
          if (variant.available) {
            this.atcBtn.disabled = false;
            this.atcLabel.textContent = this.atcLabelDefault;
          } else {
            this.atcBtn.disabled = true;
            this.atcLabel.textContent = 'Sold out';
          }
        }

        this.updateOptionAvailability();
        this.hideError();
      }

      updateOptionAvailability() {
        this.optionButtons.forEach((button) => {
          const position = Number(button.dataset.optionPosition);
          const value = button.dataset.value;
          const available = this.variants.some((variant) => {
            if (!variant.available) return false;
            if (position === 1 && variant.option1 !== value) return false;
            if (position === 2 && variant.option2 !== value) return false;
            if (position === 3 && variant.option3 !== value) return false;

            if (position !== 1 && this.selected[1] && variant.option1 !== this.selected[1]) return false;
            if (position !== 2 && this.selected[2] && variant.option2 !== this.selected[2]) return false;
            if (position !== 3 && this.selected[3] && variant.option3 !== this.selected[3]) return false;
            return true;
          });
          button.disabled = !available;
        });
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.hidden = false;
        this.errorEl.textContent = message || 'Unable to add to cart';
      }

      async onSubmit(event) {
        event.preventDefault();
        if (!this.form || this.atcBtn?.disabled) return;

        this.hideError();
        this.atcBtn?.setAttribute('aria-disabled', 'true');

        const formData = new FormData(this.form);
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }

        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });
          const data = await response.json();

          if (data.status) {
            this.showError(data.description || data.message);
            return;
          }

          if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'club-product-card',
              productVariantId: formData.get('id'),
              cartData: data,
            });
          }

          this.closeQuickView();

          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(data);
          } else if (!cart) {
            window.location = window.routes?.cart_url || '/cart';
          }
        } catch (error) {
          this.showError('Unable to add to cart');
        } finally {
          this.atcBtn?.removeAttribute('aria-disabled');
        }
      }
    }

    customElements.define('club-product-card', ClubProductCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-sticky-button"] && !Shopify.designMode) return;
  try {
    document.querySelector('#make-enquiry-button--sticky').addEventListener('click', () => {
    if (window.innerWidth < 1200) {
      document.querySelector('custom-header').classList.remove('custom-header--hidden');
      setTimeout(() => {
        document.querySelector('#mobile-menu__drawer-btn--open').click();
        document.querySelector('#mobile-contact-trigger').click();
      }, 200);
    } else {
      document.querySelectorAll('.contact-drawer-trigger').forEach((trigger) => {
        trigger.click();
        document.querySelectorAll('#inquiry-form-panel').forEach((form) => {
          form.classList.remove('hidden');
        });
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const stickyAtc = document.getElementById('sticky-atc');
    const mainButtonContainer = document.querySelector('#atc-enquiry-buttons');

    if (!stickyAtc) {
      console.error('Sticky ATC element not found');
      return;
    }

    // Track visibility state of different sections
    let isMainButtonVisible = false;
    let isCollectionVisible = false;
    let isFooterVisible = false;

    function updateStickyVisibility() {
      const isMobile = window.innerWidth <= 1024;

      // On desktop, hide only when main button is visible
      if (!isMobile) {
        if (isMainButtonVisible) {
          hideStickyBar();
        } else {
          showStickyBar();
        }
        return;
      }

      // On mobile, hide if ANY of the sections are visible
      if (isMainButtonVisible || isCollectionVisible || isFooterVisible) {
        hideStickyBar();
      } else {
        showStickyBar();
      }
    }

    function hideStickyBar() {
      stickyAtc.classList.remove('sticky-atc--visible');
      stickyAtc.classList.add('sticky-atc--hidden');
    }

    function showStickyBar() {
      stickyAtc.classList.remove('sticky-atc--hidden');
      stickyAtc.classList.add('sticky-atc--visible');
    }

    // Observer for main button container
    if (mainButtonContainer) {
      const mainButtonObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isMainButtonVisible = entry.isIntersecting;
            updateStickyVisibility();
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.1,
        }
      );

      mainButtonObserver.observe(mainButtonContainer);
    }

    // Observer for animated collection section (mobile only)
    const animatedCollection = document.querySelector('[data-section-type="animated-collection"]');
    if (animatedCollection) {
      const collectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isCollectionVisible = entry.isIntersecting;
            updateStickyVisibility();
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.1,
        }
      );

      collectionObserver.observe(animatedCollection);
    }

    // Observer for footer (mobile only)
    const footer = document.querySelector('.global-footer');
    if (footer) {
      const footerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isFooterVisible = entry.isIntersecting;
            updateStickyVisibility();
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.1,
        }
      );

      footerObserver.observe(footer);
    }

    // Handle resize events
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateStickyVisibility();
      }, 150);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
